import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=1b8d4245&scoped=true&"
import script from "./CreateEvent.vue?vue&type=script&lang=js&"
export * from "./CreateEvent.vue?vue&type=script&lang=js&"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=1b8d4245&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8d4245",
  null
  
)

export default component.exports